import React from 'react';
import { useState, useMemo, useEffect } from "react";
import { Box } from '@mui/material';

const FormTextArea = ({ label, value, error, helperText, ...props }) => {
    const [inputValue, setInputValue] = useState(value); 


    const handleChange = (event) => {
        if(props.updateFunction) {
            props.updateFunction(event.target.value)
        } else {
            setInputValue(event.target.value);
        }
      };

    const calculateValue = () => {
        const characterLength = 400 - value.length
        return characterLength.toString();
    };
    
    return (
    <Box style={{ 
        width: '100%', 
        height: '100%', 
        flexDirection: 'column', 
        justifyContent: 'flex-start', 
        alignItems: 'flex-start', 
        gap: 1, 
        display: 'inline-flex' ,
        position: 'relative'
    }}>
        <Box style={{ 
            alignSelf: 'stretch', 
            height: '100%', 
            paddingLeft: 12, 
            paddingRight: 12, 
            borderRadius: 4, 
            border: '1px #012A52 solid', 
            flexDirection: 'column', 
            justifyContent: 'center', 
            alignItems: 'center', 
            display: 'flex' 
        }}>
            <Box style={{ 
                alignSelf: 'stretch', 
                justifyContent: 'center', 
                alignItems: 'center', 
                gap: 8, 
                display: 'inline-flex',
            }}>
                {/* <input style={{ 
                    flex: '1 1 0', 
                    border: 'none', 
                    padding: '10px 2px', 
                    boxSizing: 'border-box', 
                    outline: 'none', 
                    width: '100%', 
                    height: '100%' 
                }} {...props} value={inputValue} onChange={handleChange} />
                 */}
                <textarea value={value} onChange={handleChange} style={{width: '100%', resize:'none', border: 'none', outline: 'none', fontFamily:'Arial', fontSize:'16px'}} rows={6} cols={50} maxLength={400}/>
            </Box>
        </Box>
        <Box style={{ 
            alignSelf: 'stretch', 
            marginBottom: 0,
            fontSize: '10px',
            textAlign: 'right'
            }}>
            Characters remaining: {calculateValue()}
        </Box>
        {error && <div style={{ color: 'red', fontSize: 12, marginTop: 4 }}>{helperText}</div>}
    </Box>
    )
};

export default FormTextArea;
